<template>
    <section class="home-container">
        <MasterPage title="账户信息">
            <div slot="title-icon">
                <Icon type="ios-contact" />
            </div>
            <div slot="searchContent">
                <Form :label-width="200" v-if="currentUser != null">
                    <FormItem label="账户头像：">
                        <img :src="`food/${currentUser.imageUrl}`" style="max-height: 125px;max-width: 100%">
                    </FormItem>
                    <FormItem label="后台账户：">
                        {{currentUser.loginName}}
                    </FormItem>
                    <FormItem label="账户名称：">
                        {{currentUser.realName}}
                    </FormItem>
                    <FormItem label="账户状态：">
                        {{currentUser.isLock?'禁用':'启用'}}
                    </FormItem>
                    <FormItem label="账户角色：">
                        <span v-for="role in currentUser.role" :key="role" style="margin-right: 5px">{{role}}</span>
                    </FormItem>
                    <FormItem >
                        <Button type="info" icon="ios-search" @click="updateModel = true">修改密码</Button>
                    </FormItem>
                </Form>
            </div>
        </MasterPage>
        <Modal v-model="updateModel" :loading="updateloading" title="修改密码" @on-ok="updatePassword" @on-cancel="cancel">
            <Form :label-width="100">
                <FormItem  label="原密码：">
                    <Input type="password" v-model.trim="olpassword" autocomplete="new-password" placeholder="请输入" />
                </FormItem>
                <FormItem  label="新密码：">
                    <Input type="password" v-model.trim="password" autocomplete="new-password" placeholder="请输入" />
                </FormItem>
                <FormItem label="确认密码：">
                    <Input type="password" v-model.trim="repassword" autocomplete="new-password"  placeholder="请输入" />
                </FormItem>
            </Form>
        </Modal>
    </section>
</template>

<script>
    import MasterPage from '@/components/Master'
    export default {
        components:{
            MasterPage
        },
        data(){
            return{
                aaa:'',
                updateModel:false,
                updateloading:false,
                olpassword:'',
                password:'',
                repassword:'',
                currentUser: null
            }
        },
        created(){
            this.aaa = localStorage.activeMenuName
            this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'))
        },
        methods:{
            updatePassword(){
                if (this.olpassword.length<=0){
                    return this.$Message.warning('请输入原密码');
                }
                if (this.password.length<=0){
                    return this.$Message.warning('请输入新密码');
                }
                if (this.password != this.repassword){
                    return this.$Message.warning('两次密码不一致');
                }
                this.updateloading = true
                this.$http.post('systemUser/updatePassword',{
                    oldPassword:this.olpassword,
                    password:this.password,
                }).then(function (res) {
                    this.cancel()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '密码修改成功'});
                        this.$router.replace('/')
                    }else {
                        this.$Notice.error({title:'密码修改失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancel()
                    this.myError(res.body)
                })
            },
            cancel(){
                this.updateModel = false
                this.password = this.repassword = ''
            },
        }
    }
</script>

<style lang="postcss" scoped type="scss">
    .home-container{

    }
</style>
